import { createApi } from '@reduxjs/toolkit/query/react';

import { apiSahServiceHpts } from '~constants/api';

import { Request, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

import { SahServiceHpt } from '~lookups/models';

export const typePrefix = 'sah-service-hpts';

export const sahServiceHptsApi = createApi({
  reducerPath: 'sahServiceHptsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiSahServiceHpts }),
  tagTypes: ['sah-service-hpts'],
  endpoints: (builder) => ({
    getSahServiceHpts: builder.query<SahServiceHpt[], Request | void>({
      query: (params) => ({ url: '', method: 'GET', params }),
      providesTags: [{ type: 'sah-service-hpts', id: 'LIST' }],
      transformResponse: (payload) => unwrap<SahServiceHpt[]>(payload),
    }),
    getSahServiceHptsByService: builder.query<SahServiceHpt[], string>({
      query: (serviceId) => ({ url: `/service/${serviceId}`, method: 'GET' }),
      providesTags: (result, error, serviceId) => [{ type: 'sah-service-hpts', id: serviceId }],
      transformResponse: (payload) => unwrap<SahServiceHpt[]>(payload),
    }),
  }),
});

export const { useGetSahServiceHptsQuery, useGetSahServiceHptsByServiceQuery } = sahServiceHptsApi;
